export const syncStatus = [
  'In Progress',
  'Completed',
  'Failed'
];
